import { SET_DEFAULT_LOCATIONS_SORTING } from '../constants/action-types';
export const setDefaultLocationsSorting = () => ({
    type: SET_DEFAULT_LOCATIONS_SORTING,
});
